export default {
  "logout-success": "登出成功",
  "logout-error": "登出失败",
  confirm: "确认",
  copySuccess: "复制成功",
  server: {
    selectServer: "选择服务器",
    serverAmerica: "America",
    serverEurope: "Europe",
    serverAsia: "Asia",
    serverHMT: "HMT",
    serverSEA: "SEA",
    noRole: "暂无角色，请先进入游戏",
    noRole2: "暂无角色",
    noOtherRole: "查询不到其他角色，无法切换",
  },
  uidlogin: {
    enterCode: "请输入验证码",
    enterCode2: "请输入正确的验证码",
    sendCode: "发送验证码",
    agree: "请阅读并同意《用户协议》和《隐私政策》",
    sended: "已发送",
    tipUid: "请输入UID",
    tipUid2: "请输入正确的UID",
    login: "登录",
    loginFail: "登录失败,请检查uid和验证码是否正确",
    loginSuccess: "登录成功",
    sendFail: "查询不到角色",
    sendFail2: "发送失败",
    sendFast: "发送过于频繁",
    sendFast2: "发送过于频繁,请在{time}后再试",
    codeInvaild: "验证码已失效",
  },
  "share-tips": "长按保存图片分享",
};
